import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

const http = Vue.axios.create({
  baseURL: process.env.VUE_APP_WEBSITE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

http.interceptors.request.use(
  function(config) {
    const token = `${localStorage.getItem('cTok')}`
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

export default http
